import api from '../config/api';
import { isApiEnabled } from '../config/appConfig';
import { getApiData, parseApiError } from './apiUtils';

const STORAGE_KEY = 'blf_volunteer_applications';

const initialState = {
  nombreCompleto: '',
  profesion: '',
  edad: '',
  email: '',
  telefono: '',
  mensaje: '',
};

export const getVolunteerFormInitialState = () => ({ ...initialState });

const submitVolunteerApplicationLocal = (formData) => {
  const nombreCompleto = (formData.nombreCompleto || '').trim();
  const profesion = (formData.profesion || '').trim();
  const edad = (formData.edad || '').trim();
  const email = (formData.email || '').trim();
  const telefono = (formData.telefono || '').trim();
  const mensaje = (formData.mensaje || '').trim();

  if (!nombreCompleto) {
    return Promise.reject(new Error('El nombre completo es obligatorio.'));
  }

  if (!profesion) {
    return Promise.reject(new Error('La profesión u oficio es obligatoria.'));
  }

  if (!edad) {
    return Promise.reject(new Error('La edad es obligatoria.'));
  }

  if (!email) {
    return Promise.reject(new Error('El correo electrónico es obligatorio.'));
  }

  if (!telefono) {
    return Promise.reject(new Error('El teléfono es obligatorio.'));
  }

  const application = {
    id: Date.now(),
    nombre_completo: nombreCompleto,
    profesion,
    edad,
    email,
    telefono,
    mensaje,
    estado: 'pendiente',
    creado_en: new Date().toISOString(),
  };

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    const stored = raw ? JSON.parse(raw) : [];
    const updated = Array.isArray(stored) ? [application, ...stored] : [application];
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch (error) {
    return Promise.reject(new Error('No se pudo guardar la solicitud.'));
  }

  return Promise.resolve(application);
};

const validateVolunteerForm = (formData) => {
  const nombreCompleto = (formData.nombreCompleto || '').trim();
  const profesion = (formData.profesion || '').trim();
  const edad = (formData.edad || '').trim();
  const email = (formData.email || '').trim();
  const telefono = (formData.telefono || '').trim();

  if (!nombreCompleto) {
    throw new Error('El nombre completo es obligatorio.');
  }

  if (!profesion) {
    throw new Error('La profesión u oficio es obligatoria.');
  }

  if (!edad) {
    throw new Error('La edad es obligatoria.');
  }

  if (!email) {
    throw new Error('El correo electrónico es obligatorio.');
  }

  if (!telefono) {
    throw new Error('El teléfono es obligatorio.');
  }

  return {
    nombre_completo: nombreCompleto,
    profesion,
    edad,
    email,
    telefono,
    mensaje: (formData.mensaje || '').trim(),
  };
};

export const submitVolunteerApplication = (formData) => {
  if (!isApiEnabled()) {
    return submitVolunteerApplicationLocal(formData);
  }

  let payload;

  try {
    payload = validateVolunteerForm(formData);
  } catch (error) {
    return Promise.reject(error);
  }

  return api
    .post('/voluntariado_crear.php', payload)
    .then((response) => getApiData(response, 'No se pudo guardar la solicitud.'))
    .catch((error) => {
      throw parseApiError(error);
    });
};
